/* eslint-disable indent */
import React, { useState, useEffect } from 'react';
import { connect, useLocation } from 'umi';
// import { useIntl } from 'umi';
import copy from 'copy-to-clipboard';
import QRCode from 'qrcode.react';

import classnames from 'classnames';
import { Modal, Toast } from 'antd-mobile';
import { CopyOutlined } from '@ant-design/icons';
import useGCPI18n from '@/hooks/useGCPI18n';

import { Clickable } from '@/components';
import { goBack, getImgUrl, onHistoryPush, appUrlJump } from '@/utils/utils';
import { trackSensors } from '@/utils/sensors';
import useThrottle from '@/hooks/useThrottle';
// import { POSTPAID_ITEM_PART_TYPE, SHARE_SKIN_TYPE } from '@/utils/constants';
import { SHARE_SKIN_TYPE, C2C_FONT_FAMILY } from '@/utils/constants';
import Header from '@/components/Header';
import BasicBaseSpin from '@/components/BasicBaseSpin';
import circledInfo from '@/assets/images/postPaidC2C/circled-info.svg';
// import copyImg from '@/assets/images/postPaidC2C/copy.svg';
import giftProduct from '@/assets/images/postPaidC2C/giftProduct.png';

import rightSvg from '@/assets/images/postPaidC2C/right.svg';

import styles from './index.less';

const PostPaidC2C = props => {
  const GCPI18n = useGCPI18n();
  const {
    activityDetail,
    pageRenderDetail,
    referralInfo,
    loading,
    dispatch,
    gameCode,
    referralServerUrl,
  } = props;

  const {
    promotionId: rawPromotionId,
    shareCode = '',
    shortLink = '',
    promotionMediaItemDtoList = [],
    promotionEventLinkList = [],
    templateCode,
  } = activityDetail || {};

  const promotionIdNum = Number(rawPromotionId?.split('_')[1]);
  const isPromotionIdValid = !Number.isNaN(promotionIdNum);
  const promotionId = isPromotionIdValid ? promotionIdNum : rawPromotionId;

  const promotionShareEventLinkList = promotionEventLinkList?.filter(
    item => item.modulePartType !== 'F',
  );

  const [totalEarningsVisible, setTotalEarningsVisible] = useState(false);
  const [totalInvitesVisible, setTotalInvitesVisible] = useState(false);
  const [productVisible, setProductVisible] = useState(false);
  // const [inviteInfo, setInviteInfo] = useState({});
  // const [earnPointInfo, setEarnPointInfo] = useState({});
  const { query } = useLocation();
  // eslint-disable-next-line no-unused-vars
  const { product, userDimension, entrance } = query || {};

  const initAppStr = window.localStorage.getItem('initApp');
  const initApp = JSON.parse(initAppStr) || {};
  const { userId } = initApp;
  const { mainColor, auxiliaryColor } = pageRenderDetail || {};
  const pageFontFamily = C2C_FONT_FAMILY?.[pageRenderDetail?.fontFamily];

  useEffect(() => {
    if (entrance) {
      trackSensors('ViewReferralHomePage', {
        entrance,
        promotionId,
        product,
        userDimension,
        userId,
        prod_inst_id: userId,
      });
    }
    return () => {
      if (!entrance) {
        trackSensors('ViewReferralHomePage', {
          entrance: 'deeplink',
          promotionId,
          product,
          userDimension,
          userId,
          prod_inst_id: userId,
        });
      }
    };
  }, [entrance]);

  const getTempImgNew = mediaUrl => {
    const url = getImgUrl(activityDetail?.serverUrl || referralServerUrl, mediaUrl);
    return url;
  };

  // const copySuccess = formatMessage({ id: 'INVITE_COPY_SUCCESSFULLY' });

  const handleCopy = () => {
    if (pageRenderDetail?.referralCodeType === 'referralCode') {
      trackSensors('ClickCopyCode', {
        promotionId,
        referralCode: shareCode,
        product,
        userDimension,
        userId,
        prod_inst_id: userId,
        templateCode,
      });
      copy(shareCode);
    } else {
      trackSensors('ClickCopyLink', {
        promotionId,
        referralUrl: shortLink,
        product,
        userDimension,
        userId,
        prod_inst_id: userId,
        templateCode,
      });
      copy(shortLink);
    }
    Toast.show({ icon: 'success', content: 'Copied' });
  };

  const handleRuleJump = () => {
    if (activityDetail.linkContentType === '2') {
      const pdfObj =
        (activityDetail.promotionEventLinkList || []).filter(
          item => item.modulePartType === 'F',
        )?.[0] || {};
      const title = 'Terms & Conditions'.replace(/&/g, '%amp');
      const jumpObj = {
        url: `/clp_pdf/index?content=${pdfObj.linkUrl}&title=${title}`,
        schemeType: 5,
      };
      // window.location.href = `${pdfObj.serverUrl}${pdfObj.linkUrl}`;
      window?.clp?.openAppUrl(JSON.stringify(jumpObj));
      return;
    }
    onHistoryPush(
      '/rules',
      {},
      {
        pageHeaderNew: 'Terms and Conditions',
        hideGoHomeNew: true,
        isRulesShow: false,
        fontFamily: pageFontFamily,
      },
    );
  };

  const handleRuleJumpThrottle = useThrottle(() => {
    handleRuleJump();
  }, 2000);

  const handleShare = productDetail => {
    const { eventLinkId } = productDetail || {};
    const validTypes = new Set([
      SHARE_SKIN_TYPE.SHARE_SMS,
      SHARE_SKIN_TYPE.SHARE_EMAIL,
      SHARE_SKIN_TYPE.SHARE_FACEBOOK,
      SHARE_SKIN_TYPE.SHARE,
    ]);
    const findShareableItems = (list, linkId) =>
      list
        ?.find(item => item.eventLinkId === linkId)
        ?.promotionMediaItemDtoList?.filter(item => validTypes.has(item.itemPartType)) || [];
    const findShareableItemsV2 = list =>
      list?.filter(item => validTypes.has(item.itemPartType)) || [];

    const prepareShareInfo = (curItem, itemList) => {
      if (!curItem || itemList.length === 0) return null;

      // eslint-disable-next-line no-shadow
      const { shortLink, serverUrl, imageUrl } = curItem;
      const brief = itemList[0]?.brief || '';
      const content = brief
        .replace(/#link#/g, shortLink)
        .replace(/#shareCode#/g, shareCode)
        .replace(/\${link}/g, shortLink)
        .replace(/\${shareCode}/g, shareCode);
      const shareInfo = {
        promotionId,
        shareLink: shortLink,
        shareContent: content,
      };
      if (imageUrl) shareInfo.shareImageUrl = `${serverUrl}${imageUrl}`;
      const channelShareList = itemList.filter(item => validTypes.has(item.itemPartType));
      if (channelShareList.length > 0) {
        shareInfo.channelShareList = channelShareList.map(item => ({
          title: item.title || '',
          shareChannel: item.itemPartType,
          shareImageUrl: `${serverUrl}${imageUrl}`,
          content,
          shareContent: content,
        }));
      }
      return shareInfo;
    };

    const curItem = promotionShareEventLinkList.find(item => item.eventLinkId === eventLinkId);
    const exclusiveList = findShareableItems(promotionShareEventLinkList, eventLinkId);
    const normalList = findShareableItemsV2(promotionMediaItemDtoList);
    const shareInfo = prepareShareInfo(
      curItem,
      exclusiveList.length > 0 ? exclusiveList : normalList,
    );
    if (shareInfo) {
      if (window.dito) {
        window.dito.shareOut(JSON.stringify(shareInfo));
        trackSensors('ShareViaClick', {
          promotionId,
          linkName: shareInfo?.shareLink,
          product,
          userDimension,
          userId,
          prod_inst_id: userId,
        });
      } else if (window.clp) {
        window.clp.shareBySystem(JSON.stringify(shareInfo));
        trackSensors('ShareViaClick', {
          promotionId,
          linkName: shareInfo?.shareLink,
          product,
          userDimension,
          userId,
          prod_inst_id: userId,
        });
      }
    }
  };

  const handleShareBtnClick = () => {
    trackSensors('ClickShareButton', {
      promotionId,
      product,
      userDimension,
      userId,
      prod_inst_id: userId,
    });
    if (promotionShareEventLinkList.length === 1) {
      handleShare(promotionShareEventLinkList[0]); // 原有分享逻辑
    } else if (promotionShareEventLinkList.length > 1) {
      // 有分享产品，需要展示产品分享弹框
      setProductVisible(true);
    }
  };

  const qryUserInviteInfo = () => {
    dispatch({
      type: 'postPaidC2c/referralAchievementsDXP',
      payload: gameCode,
    });
  };

  // 将十六进制颜色转换为 rgba 格式
  const hexToRgba = (hexTemp, alpha) => {
    if (!hexTemp) {
      return '';
    }
    // 去掉可能存在的 '#' 符号
    const hex = hexTemp.replace('#', '');

    // 获取红、绿、蓝的十六进制值
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // 返回 rgba 格式的字符串
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const renderPointBox = () => {
    let totalEarnings = 0;
    // 展示积分总数还是奖品数量由页面配置而定，奖品总数取rewardNum，积分总数取值逻辑：如果返回参数earnPointList存在custC积分（pointType=9），取custC积分，积分总数为earnPointNum
    // 否则取Loyalty积分（pointType=7）；如果两种积分类型都不存在，但是页面配置还要求展示积分数量，积分值为0
    if (pageRenderDetail?.myRewardDataType === '1') {
      totalEarnings = referralInfo?.rewardNum || 0;
    } else if (pageRenderDetail?.myRewardDataType === '2') {
      const earnPointList = referralInfo?.earnPointList || [];
      const iscustC = earnPointList.find(item => item.pointType === 9 || item.pointType === '9');
      const isLoyalty = earnPointList.find(item => item.pointType === 7);

      if (iscustC) {
        totalEarnings = iscustC.earnPointNum;
      } else if (isLoyalty) {
        totalEarnings = isLoyalty.earnPointNum;
      }
    }
    return (
      <div
        className={classnames(
          styles.pointBox,
          templateCode === 'OrangeReferAndEarnTemplate' && styles.pointBoxTM,
        )}
        style={
          templateCode === 'OrangeReferAndEarnTemplate'
            ? {
                backgroundColor: hexToRgba(mainColor, 0.1),
                border: `1px solid ${hexToRgba(mainColor, 0.3)}`,
              }
            : {}
        }
      >
        <Clickable
          className={styles.left}
          onClick={() => {
            trackSensors('ClickMyReferralEntrance', {
              promotionId,
              product,
              userDimension,
              userId,
              prod_inst_id: userId,
            });
            onHistoryPush('/postPaidC2CHistory');
          }}
          style={
            templateCode === 'OrangeReferAndEarnTemplate'
              ? { borderRight: `1px solid ${hexToRgba(mainColor, 0.3)}` }
              : {}
          }
        >
          <div className={styles.invites}>
            <span>{pageRenderDetail?.myReferralEntranceText}</span>
            {pageRenderDetail?.myReferralHintText && (
              <Clickable
                onClick={e => {
                  e.stopPropagation();
                  setTotalInvitesVisible(true);
                }}
              >
                <img src={circledInfo} alt="" />
              </Clickable>
            )}
          </div>
          <div className={styles.num} style={{ color: mainColor }}>
            {referralInfo?.inviteSuccessNum || 0}
          </div>
          <div
            className={styles.unit}
            style={{ color: templateCode === 'ReferAndEarnTemplate' && mainColor }}
          >
            {pageRenderDetail?.referralUnitLabel}
          </div>
        </Clickable>
        <Clickable
          className={styles.right}
          onClick={() => {
            trackSensors('ClickMyRewardEntrance', {
              promotionId,
              product,
              userDimension,
              userId,
              prod_inst_id: userId,
            });
            onHistoryPush('/postPaidC2CMyReward');
          }}
        >
          <div className={styles.invites}>
            <span>{pageRenderDetail?.myRewardEntranceText}</span>
            {pageRenderDetail?.myRewardHintText && (
              <Clickable
                onClick={e => {
                  e.stopPropagation();
                  setTotalEarningsVisible(true);
                }}
              >
                <img src={circledInfo} alt="" />
              </Clickable>
            )}
          </div>
          <div className={styles.num} style={{ color: mainColor }}>
            {totalEarnings}
          </div>
          <div
            className={styles.unit}
            style={{ color: templateCode === 'ReferAndEarnTemplate' && mainColor }}
          >
            {pageRenderDetail?.rewardUnitLabel}
          </div>
        </Clickable>
      </div>
    );
  };

  const renderMiddleButton = () => (
    <div className={styles.middleBtnWrap}>
      <Clickable
        className={styles.middleBtn}
        style={{ background: mainColor }}
        onClick={handleShareBtnClick}
      >
        {pageRenderDetail?.shareButtonText}
      </Clickable>
    </div>
  );

  const renderBottomButton = () => (
    <div className={styles.bottomBtnWrap}>
      <Clickable
        className={styles.bottomBtn}
        style={{ background: mainColor }}
        onClick={handleShareBtnClick}
      >
        {pageRenderDetail?.shareButtonText}
      </Clickable>
    </div>
  );

  const handleBottomBannerClick = () => {
    const { bottomBannerLinkInput } = pageRenderDetail || {};
    trackSensors('ClickBottomBanner', {
      bottomBannerUrl: bottomBannerLinkInput,
      promotionId,
      product,
      userDimension,
      userId,
      prod_inst_id: userId,
    });
    if (bottomBannerLinkInput) {
      appUrlJump(bottomBannerLinkInput, true);
    }
  };

  useEffect(() => {
    if (activityDetail.promotionId) {
      qryUserInviteInfo();
    }
  }, [activityDetail]);

  return (
    <div className={styles.pageWrap} style={{ fontFamily: pageFontFamily }}>
      <BasicBaseSpin spinning={loading} size="large">
        <Header
          className={styles.header}
          title={pageRenderDetail?.header}
          titleColor="#3E3E3E"
          titleFontFamily={pageFontFamily}
          goBack={goBack}
          hideGoHome
        />
        <div className={styles.pageInfo}>
          <div className={styles.contain}>
            {pageRenderDetail?.topBannerSwitch === 'Y' && (
              <div className={styles.banner}>
                <img
                  src={getTempImgNew(pageRenderDetail?.topBannerImag)}
                  alt=""
                  className={styles.bannerImg}
                />
                {/* <img src={getTempImg(POSTPAID_ITEM_PART_TYPE.BackgroundSkin, banner)} alt="" className={styles.bannerImg} /> */}
                {pageRenderDetail?.shareWidget === 'basicShare' &&
                  templateCode === 'ReferAndEarnTemplate' &&
                  renderPointBox()}
              </div>
            )}

            {/* <div className={styles.center} style={{ paddingTop: pageRenderDetail?.shareWidget === 'basicShare' ? '.84rem' : '.16rem' }}> */}
            <div className={styles.center}>
              {(pageRenderDetail?.widgetTitleText || pageRenderDetail?.widgetBodyText) && (
                <div className={styles.widgeBox}>
                  {pageRenderDetail?.widgetTitleText && (
                    <div className={styles.title}>{pageRenderDetail?.widgetTitleText}</div>
                  )}
                  {pageRenderDetail?.widgetBodyText && (
                    <div className={styles.body}>{pageRenderDetail?.widgetBodyText}</div>
                  )}
                </div>
              )}

              {templateCode === 'OrangeReferAndEarnTemplate' && (
                <div className={classnames(styles.copyBox, styles.copyBoxTM)}>
                  <p className={styles.title}>{pageRenderDetail?.referralCodeSectionTitle}</p>
                  <Clickable
                    className={styles.copyInfo}
                    style={{
                      backgroundColor: hexToRgba(mainColor, 0.1),
                      border: `1px dashed ${hexToRgba(mainColor, 0.3)}`,
                    }}
                    onClick={handleCopy}
                  >
                    <div
                      className={styles.shareCode}
                      title={
                        pageRenderDetail?.referralCodeType === 'referralCode'
                          ? shareCode
                          : shortLink
                      }
                      style={{
                        maxWidth:
                          pageRenderDetail?.copyCodeButtonIconShow === 'Y' ? '1.9rem' : '2.1rem',
                        fontSize:
                          pageRenderDetail?.referralCodeType === 'referralCode'
                            ? '.24rem'
                            : '.14rem',
                      }}
                    >
                      {pageRenderDetail?.referralCodeType === 'referralCode'
                        ? shareCode
                        : shortLink}
                    </div>
                    <div className={styles.copyWrap}>
                      {/* <img src={copyImg} alt="" className={styles.copyImg} /> */}
                      <CopyOutlined
                        style={{
                          marginRight: '0.04rem',
                          color: mainColor,
                          fontSize: '0.16rem',
                          marginLeft: '0.02rem',
                        }}
                      />
                      {pageRenderDetail?.copyCodeButtonIconShow === 'Y' && (
                        <span className={styles.copyText} style={{ color: mainColor }}>
                          {pageRenderDetail?.copyCodeButtonText}
                        </span>
                      )}
                    </div>
                  </Clickable>
                </div>
              )}

              {pageRenderDetail?.shareButtonLocation === '1' &&
                templateCode === 'OrangeReferAndEarnTemplate' &&
                renderMiddleButton()}

              {/* <img src={getTempImg(POSTPAID_ITEM_PART_TYPE.CenterSkin1, center1)} className={styles.centerImg} alt="" /> */}
              {pageRenderDetail?.referralProcessBarSwitch === 'Y' && (
                <>
                  {pageRenderDetail?.barTitle && (
                    <div className={styles.barTitle}>{pageRenderDetail?.barTitle}</div>
                  )}
                  {pageRenderDetail?.barImag && (
                    <img
                      src={getTempImgNew(pageRenderDetail?.barImag)}
                      className={styles.centerImg}
                      alt=""
                    />
                  )}
                </>
              )}

              {pageRenderDetail?.showQrCode === 'Y' && (
                <div className={styles.qrCodeBox}>
                  <div className={styles.title}>{pageRenderDetail?.qrCodeSectionTitle}</div>
                  <div className={styles.qrCode}>
                    <QRCode
                      className={styles.qrCode}
                      value={
                        pageRenderDetail?.referralCodeType === 'referralCode'
                          ? shareCode
                          : shortLink
                      }
                    />
                  </div>
                </div>
              )}

              {templateCode === 'ReferAndEarnTemplate' ? (
                <div className={styles.copyBox}>
                  <p className={styles.title}>{pageRenderDetail?.referralCodeSectionTitle}</p>
                  <Clickable
                    className={styles.copyInfo}
                    style={{
                      backgroundColor: hexToRgba(auxiliaryColor, 0.1),
                      border: `1px dashed ${hexToRgba(auxiliaryColor, 0.3)}`,
                    }}
                    onClick={handleCopy}
                  >
                    <div
                      className={styles.shareCode}
                      title={
                        pageRenderDetail?.referralCodeType === 'referralCode'
                          ? shareCode
                          : shortLink
                      }
                      style={{
                        maxWidth:
                          pageRenderDetail?.copyCodeButtonIconShow === 'Y' ? '1.9rem' : '2.1rem',
                        fontSize:
                          pageRenderDetail?.referralCodeType === 'referralCode'
                            ? '.24rem'
                            : '.14rem',
                      }}
                    >
                      {pageRenderDetail?.referralCodeType === 'referralCode'
                        ? shareCode
                        : shortLink}
                    </div>
                    <div className={styles.copyWrap}>
                      {/* <img src={copyImg} alt="" className={styles.copyImg} /> */}
                      <CopyOutlined
                        style={{
                          marginRight: '0.04rem',
                          color: auxiliaryColor,
                          fontSize: '0.16rem',
                          marginLeft: '0.02rem',
                        }}
                      />
                      {pageRenderDetail?.copyCodeButtonIconShow === 'Y' && (
                        <span className={styles.copyText} style={{ color: auxiliaryColor }}>
                          {pageRenderDetail?.copyCodeButtonText}
                        </span>
                      )}
                    </div>
                  </Clickable>
                </div>
              ) : (
                renderPointBox()
              )}

              {pageRenderDetail?.shareButtonLocation === '1' &&
                templateCode === 'ReferAndEarnTemplate' &&
                renderMiddleButton()}

              {pageRenderDetail?.bottomBannerSwitch === 'Y' && (
                <div className={styles.bottomBannerWrap}>
                  {pageRenderDetail?.bottomBannerTitleText && (
                    <div className={styles.bottomBannerTitle}>
                      {pageRenderDetail?.bottomBannerTitleText}
                    </div>
                  )}
                  <Clickable onClick={handleBottomBannerClick}>
                    <img
                      src={getTempImgNew(pageRenderDetail?.bottomBannerImag)}
                      className={styles.center2Img}
                      alt=""
                    />
                  </Clickable>
                </div>
              )}
              {/* <img src={getTempImgNew(pageRenderDetail?.barImag)} className={styles.center2Img} alt="" /> */}
              <Clickable
                className={styles.ruleBtn}
                onClick={handleRuleJumpThrottle}
                style={{ color: auxiliaryColor }}
              >
                {pageRenderDetail?.termsAndConditionButtonText}
              </Clickable>
            </div>
          </div>

          {pageRenderDetail?.shareButtonLocation === '2' && renderBottomButton()}
        </div>
      </BasicBaseSpin>
      {totalInvitesVisible && (
        <Modal
          visible
          draggable={false}
          bodyClassName={styles.modalStyles}
          bodyStyle={{ fontFamily: pageFontFamily }}
        >
          <div className={styles.totalEarningsCenter}>
            <div className={styles.title}>{pageRenderDetail?.myReferralEntranceText}</div>
            <div className={styles.tip}>{pageRenderDetail?.myReferralHintText}</div>
            <Clickable
              className={styles.btn}
              onClick={() => setTotalInvitesVisible(false)}
              style={{ background: mainColor }}
            >
              {GCPI18n('btn_close')}
            </Clickable>
          </div>
        </Modal>
      )}
      {totalEarningsVisible && (
        <Modal
          visible
          draggable={false}
          bodyClassName={styles.modalStyles}
          bodyStyle={{ fontFamily: pageFontFamily }}
        >
          <div className={styles.totalEarningsCenter}>
            <div className={styles.title}>{pageRenderDetail?.myRewardEntranceText}</div>
            <div className={styles.tip}>{pageRenderDetail?.myRewardHintText}</div>
            <Clickable
              className={styles.btn}
              onClick={() => setTotalEarningsVisible(false)}
              style={{ background: mainColor }}
            >
              {GCPI18n('btn_close')}
            </Clickable>
          </div>
        </Modal>
      )}
      {productVisible && (
        <Modal
          visible
          draggable={false}
          bodyClassName={styles.modalStyles}
          bodyStyle={{ fontFamily: pageFontFamily }}
        >
          <div className={styles.productShareBox}>
            <div className={styles.title}>{pageRenderDetail?.sharingSelectionPopupText}</div>
            <div className={styles.list}>
              {(promotionShareEventLinkList || []).map(it => (
                <Clickable
                  className={styles.product}
                  key={it.shortLink}
                  onClick={() => handleShare(it)}
                >
                  <div className={styles.right}>
                    <img
                      src={it?.imageUrl ? getImgUrl(it.serverUrl, it.imageUrl) : giftProduct}
                      alt=""
                    />
                    <span>{it.linkName}</span>
                  </div>
                  <img src={rightSvg} alt="" />
                </Clickable>
              ))}
            </div>
            <Clickable className={styles.closeBtn} onClick={() => setProductVisible(false)}>
              {GCPI18n('btn_close')}
            </Clickable>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default connect(({ index, postPaidC2c, loading }) => ({
  pageRenderDetail: index.pageRenderDetail,
  referralServerUrl: index.referralServerUrl,
  referralInfo: postPaidC2c.referralInfo,
  activityDetail: index.activityDetail,
  gameCode: index.gameCode,
  loading:
    loading.effects['postPaidC2c/qryUserInviteInfo'] ||
    loading.effects['index/qryLuckyDrawDetail'] ||
    false,
}))(PostPaidC2C);
